import { render } from "./Servicetable.vue?vue&type=template&id=05d38725"
import script from "./Servicetable.vue?vue&type=script&lang=js"
export * from "./Servicetable.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__